import { useEffect } from "react";
import { SITE_URL, IMAGES } from "@/data/site";

const abs = (u) => (u && u.startsWith("http") ? u : `${SITE_URL}${u || ""}`);

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Per-page SEO: title, description, canonical, Open Graph, Twitter, JSON-LD.
 * Rendered near the top of every page component.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image = IMAGES.hero,
  type = "website",
  jsonLd = [],
  noindex = false,
}) {
  const jsonLdStr = JSON.stringify(jsonLd);
  useEffect(() => {
    const url = abs(path);
    const img = abs(image);

    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", noindex ? "noindex, follow" : "index, follow");

    // Canonical
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);

    // Open Graph
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);
    upsertMeta("property", "og:site_name", "Golden Touch Lash and Brow");

    // Twitter
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", img);

    // JSON-LD (managed set, replaced each route)
    const prev = document.head.querySelectorAll('script[data-seo-jsonld="1"]');
    prev.forEach((n) => n.remove());
    const blocks = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
    blocks.filter(Boolean).forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "1");
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
    });
  }, [title, description, path, image, type, noindex, jsonLdStr]);

  return null;
}
